import firebaseSrv from '@/services/firebaseSrv.js'
import _ from 'lodash/core'
// import router from '@/router.js'
export const namespaced = true

export const state = {
  entry: {},
  entries: []
}
export const mutations = {
  GET_ENTRY(state, entry) {
    state.entry = entry
  },
  GET_ENTRIES(state, entries) {
    state.entries = entries
  },
  UPDATE_ENTRIES(state, eid) {
    // update local vuex
    let entryArray = state.entries.filter(entry => entry.eid != eid)
    entryArray.push(state.entry)
    state.entries = entryArray
  },
  DELETE_ENTRY(state, eid) {
    let entryArray = state.entries.filter(entry => entry.eid != eid)
    state.entries = entryArray
  },
  UPDATE_ENTRY(state, ob) {
    state.entry[ob.key] = ob.value
  },
  FINALISE_ENTRY(state, eid) {
    state.entry.complete = true
    if (state.entries.length) {
      let entryIndex = state.entries.findIndex(entry => entry.eid == eid)
      state.entries[entryIndex].complete = true
    }
  },
  DELETE_PHOTO(state, pid) {
    delete state.entry.photos[pid]
  },
  PUSH_PHOTO(state, eid) {
    let thisEntry = state.entries.filter(entry => entry.eid === eid)
    // console.log('All the photos: ' + JSON.stringify(state.photo.photos))
    thisEntry.photos = state.photo.photos
    state.entry.photos = state.photo.photos
  },
  UPDATE_PHOTOS(state, photos) {
    state.entry.photos = photos

    state.entries.forEach(entry => {
      // console.log(entry)
      if (entry.eid == state.entry.eid) {
        entry.photos = photos
      }
    })
  }
}
export const actions = {
  // UPDATE LOCAL VUEX STORE
  update({ commit }, payload) {
    commit('UPDATE_ENTRY', { value: payload.value, key: payload.key })
  },
  // UPDATE ENTRY
  updateEntry({ state, dispatch }, uid) {
    // console.log(JSON.stringify(state.entry))
    return (
      firebaseSrv
        .updateEntry(state.entry, uid)
        // .then(() => console.log('it workked, update'))
        .catch(error => {
          const notification = {
            title: 'There is a problem updating your entry',
            type: 'error',
            code: error.code,
            message: error.message
          }
          // console.log(notification)
          return dispatch('notification/add', notification, { root: true })
        })
    )
  },
  finaliseEntry({ commit, dispatch }, ob) {
    let eid = ob.eid
    let uid = ob.hasOwnProperty('uid') ? ob.uid : undefined
    return firebaseSrv
      .finaliseEntry(eid, uid)
      .then(() => commit('FINALISE_ENTRY', eid))
      .then(() => {
        const notification = {
          title: 'Well done! ',
          type: 'success',
          code: 'success.code',
          message:
            'You successfully finalised your entry. Your project will be reviewed by the judges'
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem finalising your entry',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // FETCH ENTRY
  fetchEntry({ commit, dispatch }, ob) {
    let eid = ob.eid
    let uid = ob.hasOwnProperty('uid') ? ob.uid : undefined
    firebaseSrv
      .readUser(uid)
      .then(user => {
        // pull and return the entries from the DB response
        const userOb = user.data()
        // update the vuex user store
        // commit('user/GET_USER', userOb.user, { root: true })
        const entry = userOb.entries[eid]
        // console.log('Fetch Entry: ' + JSON.stringify(entry))
        return entry
      })
      .then(entry => {
        // const photos = _.values(entry.photos)

        return Promise.all([
          commit('GET_ENTRY', entry),
          commit('photo/GET_PHOTOS', entry.photos, { root: true })
        ])
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem fetching your entry. right here',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // FETCH ENTRIES
  fetchEntries({ commit, dispatch }, uid) {
    firebaseSrv
      .readUser(uid)
      .then(user => {
        // pull and return the entries from the DB response
        const userOb = user ? user.data() : null
        return userOb ? _.values(userOb.entries) : null
      })
      .then(entries => {
        // find and return a single entry in the entries array that matches eid
        return commit('GET_ENTRIES', entries)
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem fetching your entries',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // CREATE ENTRY
  createEntry({ commit, dispatch }, entry) {
    return firebaseSrv
      .createEntry(entry)
      .then(() => {
        // console.log('CreateEntry Method: ' + JSON.stringify(entry))
        return commit('GET_ENTRY', entry)
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem creating your entry',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // CREATE BLANK ENTRY
  createBlankEntry({ commit, dispatch, state }, entryOb) {
    const entry = entryOb
    commit('GET_ENTRY', entry)
      .then(() => {
        return firebaseSrv.createEntry(state.entry)
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem creating your entry',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // DELETE ENTRIES
  deleteEntry({ commit }, deleteOb) {
    let eid = Number(deleteOb.eid) //numerize eid
    let uid = undefined
    if (deleteOb.hasOwnProperty('uid')) {
      uid = deleteOb.uid
    }
    // console.log('deleteEntryFunction:' + uid, eid)
    // console.log('here in the delete function')
    firebaseSrv.deleteEntry(eid, uid).then(() => commit('DELETE_ENTRY', eid))
  }
}
export const getters = {
  getEntryById: state => eid => {
    return state.entries.find(entry => entry.eid === eid)
  },
  entryCount: state => {
    return state.entries ? state.entries.length : 0
  },
  wordCount: state => {
    return state.statement ? state.statement.trim().split(/\s+/).length : '0'
  }
}
